'use strict';

angular.module('shop').controller('SummaryController', function($rootScope, $scope, $window, $state, ShopService, Toast, LANG) {
	$scope.cart = ShopService.getCart();

	if (!$scope.cart ||  $scope.cart.cartArticles.length === 0) {
		$state.go('checkout');
		return;
	}
	
	$scope.loading = true;
	$scope.payedOrder = false;
	
	ShopService.checkout($scope.cart).then(function() {
		$scope.getSummary();
	});
	
	$scope.getSummary = function() {
		$scope.loading = true;

		ShopService.getSummary($scope.cart).then(function(summary) {

			// If total price of order is 0 we skip Klarna checkout
			var totalPrice = summary.payMethodPrice + summary.missingPrice;
			if (totalPrice == 0) {
				$scope.payedOrder = true;
			}

			if (!summary.summaryArticles || summary.summaryArticles.length === 0) {
				$state.go('checkout');
				return;
			}
			
			if (summary.summaryArticles && summary.summaryArticles.length > 0) {
				_.each(summary.summaryArticles, function(article) {
					article.product = _.find($scope.cart.cartArticles, {shopArticleID: article.shopArticleID});
				});
			}

			if (summary.giftCodePrice > 0) {
				$scope.giftcard = true;
			}

			summary.formatedDeliveryDate = moment(summary.deliveryDate).locale(LANG).format('dddd D MMMM');

			$scope.summary = summary;
			$scope.loading = false;
			$rootScope.$emit('shop-cart.update');
		});
	};

	$scope.pay = function() {
		$state.go('payment');
	};

	$scope.order = function() {
		$state.go('confirmation');
	};

});